// extracted by mini-css-extract-plugin
export default {"About1Main":"About1_About1Main__CZNk8","AboutParent":"About1_AboutParent__GAYMp","AboutChild":"About1_AboutChild__BQDrD"};